import angular from 'angular';

const levelRebusServices = angular.module('applicationModule.levelRebusesServices', []);

levelRebusServices.factory('LevelRebus', ['LevelRebusAPI', function (LevelRebusAPI) {
    'use strict';

    return {
        getList: function (appId, params) {
            return LevelRebusAPI.getList(appId, params).then(function (response) {
                return response.data;
            });
        },
        get: function (levelRebusId) {
            return LevelRebusAPI.getLevelRebus(levelRebusId);
        },
        save: function (levelRebus, editMode) {
            if (editMode) {
                return LevelRebusAPI.editLevelRebus(levelRebus);
            } else {
                return LevelRebusAPI.createLevelRebus(levelRebus);
            }
        },
        remove: function (levelRebusId) {
            return LevelRebusAPI.removeLevelRebus(levelRebusId);
        }
    };
}]);

levelRebusServices.service('LevelRebusAPI', ['$http', 'AppsoupAPI', function ($http, AppsoupAPI) {
    'use strict';

    const API_URL = AppsoupAPI.API_URL + '/app/level-rebus/';

    this.getList = function (appId, params) {
        return $http.get(API_URL, {params: angular.extend(AppsoupAPI.getTableParams(params), {app_id: appId})});
    };

    this.createLevelRebus = function (levelRebus) {
        return $http.post(API_URL, levelRebus);
    };
    this.getLevelRebus = function (levelRebusId) {
        return $http.get(API_URL + levelRebusId);
    };

    this.editLevelRebus = function (levelRebus) {
        return $http.put(API_URL + levelRebus.id, levelRebus);
    };

    this.removeLevelRebus = function (levelRebusId) {
        return $http.delete(API_URL + levelRebusId);
    };

}]);

export default levelRebusServices;
